import { z } from "zod";

export const buildAboutMeSchema = (t: (key: string) => string) =>
  z.object({
    firstName: z
      .string()
      .trim()
      .min(1, { message: t("validation.firstNameRequired") })
      .min(2, { message: t("validation.firstNameMin") })
      .max(100, { message: t("validation.firstNameMax") }),
    lastName: z
      .string()
      .trim()
      .min(1, { message: t("validation.lastNameRequired") })
      .min(2, { message: t("validation.lastNameMin") })
      .max(100, { message: t("validation.lastNameMax") }),
    phone: z
      .string()
      .trim()
      .min(1, { message: t("validation.phoneRequired") })
      .min(9, { message: t("validation.phoneMin") })
      .max(15, { message: t("validation.phoneMax") }),
    residency: z
      .string()
      .trim()
      .min(1, { message: t("validation.residencyRequired") })
      .max(100, { message: t("validation.residencyMax") }),
  });